<script>
  import { onMount } from "svelte";
  import { fly } from "svelte/transition";
  import ProgressBar from "../components/ProgressBar.svelte";
  import {
    AppAccessGranted,
    UserToken,
    UserData,
  } from "../stores/LoggedUser.js";
  import { ServerRequest } from "../service/ServerRequest.js";
  import Input from "../components/form/Input.svelte";

  let token = $UserToken;
  let showPanel = false;

  let checkingPassword = false;
  let nickname = "";
  let pwd = "";
  let type = "password";
  let errorBag = {};

  let progressTimeMS = 600;

  onMount(() => {
    console.log($AppAccessGranted);
    if ($AppAccessGranted != "true") {
      window.location.href = "#/";
    }
    if ($UserToken != "") {
      window.location.href = "#/events";
    }

    const wait = setTimeout(() => {
      showPanel = true;
      clearTimeout(wait);
    }, 525);
  });

  function setType(newType) {
    type = newType;
  }

  function checkPassword() {
    errorBag = {};

    if (!nickname) {
      alert("insert nickanme");
      return;
    }

    if (!pwd) {
      alert("insert password");
      return;
    }

    checkingPassword = true;

    const wait = setTimeout(() => {
      ServerRequest.post(ServerRequest.routes.login, token, {
        nickname: nickname,
        password: pwd,
        device_name: "mobile_device",
      }).then((resp) => {
        console.log(resp);
        console.log(resp.errors);
        if (resp.status && resp.data.token) {
          UserToken.set(resp.data.token);
          setUserData(resp.data.token);
        } else if (resp.errors) {
          errorBag = resp.errors;
        } else {
          alert("Generic error on login, reload the page and retry");
        }

        checkingPassword = false;
      });

      clearTimeout(wait);
    }, progressTimeMS);
  }

  function setUserData(tkn) {
    ServerRequest.get(ServerRequest.routes.user_detaile, tkn, {}).then(
      (resp) => {
        if (resp.status && resp.data.user) {
          UserData.set(resp.data.user);
          window.location.href = "#/events";
        }
      }
    );
  }
</script>

{#if showPanel}
  <div
    class="center"
    in:fly={{ y: -400, duration: 500 }}
    out:fly={{ y: -400, duration: 500 }}
  >
    <div class="rpgui-container framed-golden" style="padding: 1rem .5rem">
      <h1>Chie sei?</h1>

      {#if checkingPassword}
        <ProgressBar timeToCompleteMS={progressTimeMS} color="green" />
      {/if}

      <div>
        <div>
          <Input
            placeholder="Nickname"
            autocomplete={false}
            label={false}
            name="nickanme"
            id="nickanme"
            bind:value={nickname}
            error={errorBag.nickname}
            disabled={false}
            required={true}
          />
        </div>
      </div>

      <div style="margin-top: 1rem;">
        {#if type == "password"}
          <Input
            placeholder="Password"
            label={false}
            inputType="password"
            name="password"
            id="password"
            bind:value={pwd}
            error={errorBag.password}
            disabled={false}
            required={true}
          />
          <span class="show_pwd" on:click={() => setType("text")}>
            mostra password
          </span>
        {:else}
          <Input
            placeholder="Password"
            label={false}
            inputType="text"
            name="password"
            id="password"
            bind:value={pwd}
            error={errorBag.password}
            disabled={false}
            required={true}
          />
          <span class="show_pwd" on:click={() => setType("password")}>
            nascondi password
          </span>
        {/if}
      </div>

      <div class="text-center" style="margin-top:1.5rem">
        <button class="rpgui-button" on:click={() => checkPassword()}>
          ENTRA
        </button>
      </div>

      <div class="text-center" style="margin-top:1.5rem">
        <span><a href="#/register">Registrati</a></span>
      </div>
    </div>
  </div>
{/if}

<style>
  .show_pwd {
    text-align: right;
    display: block;
    color: #ccc;
    margin: 0.75rem 0.5rem 0 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 300;
    text-shadow: none;
  }
</style>
